import Vue from "vue";
import PassMetadataService from "../../services/PassMetadataService";
import SiteService from "../../services/SiteService";
import PassValidator from "../../validators/PassValidator";
import PassTypeService from "../../services/PassTypeService";

const state = {
  siteId: 0,
  pass: {},
  errors: {},
  passMetadata: {},
  siteDefinition: {},
  passDefinition: {},
  passDefinitionLoaded: false,
  siteDefinitionLoaded: false,
  serverValidationErrorMessage: ""
};

const getters = {
  pass: state => state.pass,
  siteId: state => state.siteId,
  errors: state => state.errors,
  passMetadata: state => state.passMetadata,
  siteDefinition: state => state.siteDefinition,
  passDefinition: state => state.passDefinition,
  serverValidationErrorMessage: state => state.serverValidationErrorMessage
};
const actions = {
  loadPassTypeDefinition(context) {
    //Load the raw pass definition for this site
    let service = new PassTypeService();
    service.getPassTypesDefinition(context.getters.siteId).then(data => {
      context.commit("setPassDefinition", data);
      context.dispatch("refreshPassMetadata");
      context.dispatch("setPassDefaultValues");
    });
  },
  loadSiteDefinition(context) {
    //Load the raw site definition for this site
    let service = new SiteService();
    service.getSiteById(context.getters.siteId).then(data => {
      context.commit("setSiteDefinition", data);
      context.dispatch("refreshPassMetadata");
      context.dispatch("setPassDefaultValues");
    });
  },
  refreshPassMetadata(context) {
    //Calculate new pass metadata using pass and site definitions as well as pass data fields
    if (
      !context.state.siteDefinitionLoaded ||
      !context.state.passDefinitionLoaded
    ) {
      return;
    }
    let service = new PassMetadataService();
    let passMetadata = service.getPassMetadata(
      context.getters.siteDefinition,
      context.getters.passDefinition,
      context.getters.pass,
      null
    );

    context.commit("setPassMetadata", passMetadata);
  },
  setPassDefaultValues(context) {
    //Set default values, if they don't already have a value, based on passMetadata
    let passMetadata = context.getters.passMetadata;
    let fields = [];
    if (typeof passMetadata.getAllFields === "function") {
      fields = passMetadata.getAllFields();
    }
    fields.forEach(field => {
      //Only update fields that do not yet have a value
      if (field.defaultValue != "" && !context.getters.pass[field.name]) {
        context.commit("updatePass", {
          name: field.name,
          value: field.defaultValue
        });
      }
    });
  },
  validatePass(state) {
    state.commit("setServerValidationErrorMessage", "");
    return new Promise(resolve => {
      //Ensure pass has valid data fields
      state.commit("clearErrors");
      let validator = new PassValidator();
      //Validate client side
      let errorList = validator.validateLocally(
        state.getters.pass,
        state.getters.passMetadata,
        state.getters.passDefinition,
        state.getters.siteDefinition
      );
      let errorCount = 0;
      for (var x in errorList) {
        if (errorList[x] != "") {
          errorCount++;
        }
        state.commit("addError", { fieldName: x, errorMessage: errorList[x] });
      }

      if (errorCount == 0) {
        //Validate Server Side
        return validator
          .validateServerSideAndGetPrice(state.getters.pass)
          .then(data => {
            if (data.status && data.status == "500") {
              state.commit(
                "setServerValidationErrorMessage",
                "An error has occurred."
              );
            }
            if (data && data.err) {
              state.commit("setServerValidationErrorMessage", data.err);
            } else {
              state.commit("updatePass", { name: "price", value: data.total });
              state.commit("updatePass", { name: "priceDetails", value: data });
            }
            resolve();
          });
      } else {
        resolve();
      }
    });
  },
  updatePassFields(context) {
    //Set pass fields that are based on the data value of other fields.
    let service = new PassMetadataService();
    let fields = service.getFieldsToUpdate(
      context.getters.passDefinition,
      context.getters.pass
    );
    fields.forEach(field => {
      context.commit("updatePass", {
        name: field.name,
        value: field.value
      });
    });
  }
};
const mutations = {
  updatePass(state, field) {
    if (!state.pass[field.name]) {
      Vue.set(state.pass, field.name, field.value);
    } else {
      state.pass[field.name] = field.value;
    }
  },
  addError(state, field) {
    if (!state.errors[field.fieldName]) {
      Vue.set(state.errors, field.fieldName, field.errorMessage);
    } else {
      state.errors[field.fieldName] = field.errorMessage;
    }
  },
  setSiteId(state, siteId) {
    state.siteId = siteId;
    state.pass.siteId = siteId;
  },
  clear(state) {
    state.pass = {};
    state.errors = {};
  },
  clearErrors(state) {
    state.errors = {};
  },
  clearAllState(state) {
    state.siteId = 0;
    state.pass = {};
    state.errors = {};
    state.passMetadata = {};
    state.siteDefinition = {};
    state.passDefinition = {};
    state.passDefinitionLoaded = false;
    state.siteDefinitionLoaded = false;
  },
  setPassMetadata(state, data) {
    state.passMetadata = data;
  },
  setPassDefinition(state, data) {
    state.passDefinition = data;
    state.passDefinitionLoaded = true;
  },
  setSiteDefinition(state, data) {
    state.siteDefinition = data;
    state.siteDefinitionLoaded = true;
  },
  setServerValidationErrorMessage(state, data) {
    state.serverValidationErrorMessage = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
